export default __webpack_public_path__ + "static/media/closeCirclePrimary.a6ab72b6.svg";